import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { whenOptions } from "../../config/constants/options";
import { AppDispatch } from "../store";
import { getSessionDocuments } from "../../services/media.services";
import { Complaint, Diagnosis, Prescription, SessionState } from "../../types/consultation";

const initialState: SessionState = {
  formData: {
    weight: "",
    height: "",
    pulse: "",
    temperature: "",
    bp: "",
    complaint: "",
    frequency: "",
    severity: "",
    duration: "",
    date: null,
    clinicalHistory: "",
    additionalNotes: "",
    advice: "",
    test: [],
    unit: "",
    consultFlag: null,
    uuid: "",
    customerId: "",
    markDone: false,
    testInputValue: "",
    primaryPerson:"",
    secondaryPerson:""
  },
  errors: {},
  selectOptions: {
    complaint: [],
    frequency: [],
    severity: [],
    medicine: [],
    dose: [],
    when: whenOptions,
    test: [],
    diagnosis: [],
    primaryPerson:[],
    secondaryPerson:[]
  },
  tables: {
    diagnosis: [{ no: 0, diagnosis: "", duration: "", date: null, unit: "" }],
    prescription: [
      {
        no: 0,
        medicine: "",
        dose: "",
        when: "",
        frequency: "",
        duration: "",
        notes: "",
        unit: "",
      },
    ],
    complaints: [
      {
        complaint: "",
        frequency: "",
        severity: "",
        duration: "",
        unit: "",
        date: null,
      } as Complaint,
    ],
  },
  mainPaymentHistory: [],
  mediaData: {},
};

const consultationSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setFormData: (
      state,
      action: PayloadAction<Partial<SessionState["formData"]>>
    ) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setSelectOptions: (
      state,
      action: PayloadAction<Partial<SessionState["selectOptions"]>>
    ) => {
      state.selectOptions = { ...state.selectOptions, ...action.payload };
    },
    setErrors: (state, action: PayloadAction<Record<string, string>>) => {
      state.errors = action.payload;
    },
    setMediaData: (state, action: PayloadAction<any>) => {
      state.mediaData = action.payload;
    },
    setPaymentHistoryData: (state, action: PayloadAction<any>) => {
      state.mainPaymentHistory = action.payload;
    },
    setTable: (
      state,
      action: PayloadAction<{
        table: "diagnosis" | "prescription" | "complaints";
        rows: Diagnosis[] | Prescription[] | Complaint[];
      }>
    ) => {
      const { table, rows } = action.payload;
      if (table === "diagnosis") {
        state.tables.diagnosis = rows as Diagnosis[];
      } else if (table === "prescription") {
        state.tables.prescription = rows as Prescription[];
      } else if (table === "complaints") {
        state.tables.complaints = rows as Complaint[];
      }
    },
    clearErrors: (state) => {
      state.errors = {};
    },
    clearForm: (state) => {
      state.formData = {
        ...initialState.formData,
        customerId: state.formData.customerId,
      };
      state.errors = {};
      state.tables = {
        diagnosis: [
          { no: 0, diagnosis: "", duration: "", date: null, unit: "" },
        ],
        prescription: [
          {
            no: 0,
            medicine: "",
            dose: "",
            when: "",
            frequency: "",
            duration: "",
            notes: "",
            unit: "",
          },
        ],
        complaints: [
          {
            complaint: "",
            frequency: "",
            severity: "",
            duration: "",
            unit: "",
            date: null,
          } as Complaint,
        ],
      };
      state.mediaData = {};
    },
  },
});

export const {
  setFormData,
  setErrors,
  clearErrors,
  clearForm,
  setSelectOptions,
  setTable,
  setPaymentHistoryData,
  setMediaData,
} = consultationSlice.actions;

// Thunk to handle fetching media data by ID
export const getsessionMediaDataById =
  (sessionId: string): any =>
  async (dispatch: AppDispatch, getState: any) => {

    try {
      const res = await getSessionDocuments(sessionId);
      if (res?.data?.status === 200) {
        dispatch(setMediaData(res?.data?.data));
      }
    } catch (err) {
      dispatch(setMediaData({}));
      console.error("Error fetching media data:", err);
    }
  };

export default consultationSlice.reducer;
